import { render, staticRenderFns } from "./questionAnswer.vue?vue&type=template&id=5a67f6a8&scoped=true&"
import script from "./questionAnswer.vue?vue&type=script&lang=js&"
export * from "./questionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./questionAnswer.vue?vue&type=style&index=0&id=5a67f6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67f6a8",
  null
  
)

export default component.exports